/* eslint-disable react/no-children-prop */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
import {
  Flex,
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { useContext, useMemo } from "react";
import { MdPerson, MdDashboard } from "react-icons/md";
import {
  BiCoinStack,
  BiLockAlt,
  BiLogOut,
  BiPackage,
  BiUser,
  BiTransfer,
} from "react-icons/bi";
import {
  FaBoxes,
  FaEllipsisH,
  FaLocationArrow,
  FaTicketAlt,
  FaUsers,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { Car, Coins } from "lucide-react";
import { Separator } from "@repo/ui";
import { Paths } from "../../routes/paths";
import { HasPermission } from "../../utils/helper";
import { MenuItemLink } from "../../components/header/menu-item-link";
import AuthContext from "../../store/auth-context";
import Logo from "../../assets/images/logo.png";
import { useUser } from "../../hooks/use-user";

export default function Header() {
  const authCtx = useContext(AuthContext);
  const user = useUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    authCtx.logout();
  };

  const goToProfile = () => {
    navigate(Paths.profile);
  };
  const goToChangePassword = () => {
    navigate(Paths.changePassword);
  };
  // console.log("user", user);

  const headerLinks = useMemo(() => {
    const _navbar = [
      { link: "/dashboard", label: "Dashboard", icon: <MdDashboard /> },
    ];

    const children = [];
    if (HasPermission(user, "User")) {
      children.push({ label: "Users", link: Paths.users });
    }
    if (HasPermission(user, "Role")) {
      children.push({ label: "Roles", link: Paths.roles });
    }
    if (children.length > 0) {
      _navbar.push({
        to: "",
        label: "Identity ",
        icon: <BiTransfer />,
        children,
      });
    }
    if (HasPermission(user, "CashCenter")) {
      _navbar.push({
        link: Paths.cashCenter,
        label: "Cash Center",
        icon: <Coins style={{ width: "14px" }} />,
      });
    }
    if (HasPermission(user, "Customer")) {
      _navbar.push({
        link: Paths.customers,
        label: "Customers",
        icon: <FaUsers />,
      });
    }
    if (HasPermission(user, "ServicePoint")) {
      _navbar.push({
        link: Paths.locations,
        label: "Locations",
        icon: <FaLocationArrow />,
      });
    }
    if (HasPermission(user, "Vehicle")) {
      _navbar.push({
        link: Paths.vehiclesList,
        label: "Vehicles",
        icon: <Car style={{ width: "14px" }} />,
      });
    }
    if (HasPermission(user, "Stock")) {
      _navbar.push({ link: Paths.stock, label: "Stock", icon: <FaBoxes /> });
    }
    if (HasPermission(user, "Currency")) {
      _navbar.push({
        link: Paths.currency,
        label: "Currencies",
        icon: <BiCoinStack />,
      });
    }
    if (HasPermission(user, "Consumable")) {
      _navbar.push({
        link: Paths.consumable,
        label: "Consumables",
        icon: <BiPackage />,
      });
    }
    _navbar.push({
      link: Paths.ticketsList,
      label: "Tickets List",
      icon: <FaTicketAlt />,
    });
    // _navbar.push({
    //   to: "",
    //   label: "More",
    //   children: [{ label: "Tickets", link: Paths.ticketsList }],
    // });
    return _navbar;
  }, [user]);
  const menuLinks = headerLinks.slice(6) || [];
  const navLinks = headerLinks.slice(0, 6) || [];
  return (
    <header className="fixed-header">
      <nav
        className=" flex  items-center  p-6 lg:px-6 lg:py-3.5 w-full"
        aria-label="Global"
      >
        <img className="w-[65px] object-contain" src={Logo} alt="" zIndex={2} />
        <Separator orientation="vertical" className="h-8 mx-8" />
        <div className="lg:flex gap-[25px]">
          {navLinks.map((link, index) => {
            return (
              <MenuItemLink
                key={index}
                to={link.link}
                label={link.label}
                icon={link.icon}
                children={link.children || undefined}
              />
            );
          })}

          {menuLinks?.length > 0 ? (
            <Menu>
              <MenuButton
                as={IconButton}
                rounded="50%"
                maxW="12px"
                minH="12px"
                icon={<FaEllipsisH />}
              />
              <MenuList>
                {menuLinks.map((link, index) => (
                  <MenuItem
                    key={index}
                    as={Link}
                    variant="secondary"
                    style={{ justifyContent: "flex-start" }}
                    leftIcon={link.icon}
                    fontSize="14px"
                    to={link.link}
                  >
                    {link.label}
                  </MenuItem>
                ))}
              </MenuList>
            </Menu>
          ) : (
            <></>
          )}
        </div>
        <Flex ml="auto" align="center" justifyContent="center" gap="12px">
          <span className="uppercase text-sm">{user.DisplayName}</span>
          <Menu>
            <MenuButton
              as={IconButton}
              rounded="50%"
              maxW="12px"
              minH="12px"
              icon={<MdPerson />}
            />
            <MenuList>
              <MenuItem
                as={Button}
                variant="secondary"
                style={{ justifyContent: "flex-start" }}
                leftIcon={<BiUser />}
                fontSize="14px"
                onClick={goToProfile}
              >
                Profile
              </MenuItem>
              <MenuItem
                as={Button}
                variant="secondary"
                style={{ justifyContent: "flex-start" }}
                leftIcon={<BiLockAlt />}
                fontSize="14px"
                onClick={goToChangePassword}
              >
                Change Password
              </MenuItem>
              <MenuItem
                as={Button}
                variant="secondary"
                style={{ justifyContent: "flex-start" }}
                leftIcon={<BiLogOut />}
                fontSize="14px"
                type="button"
                onClick={handleLogout}
              >
                Logout
              </MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </nav>
    </header>
  );
}
